import { render, staticRenderFns } from "./proy-unidad.vue?vue&type=template&id=3df7a712"
import script from "./proy-unidad.vue?vue&type=script&lang=js"
export * from "./proy-unidad.vue?vue&type=script&lang=js"
import style0 from "./proy-unidad.vue?vue&type=style&index=0&id=3df7a712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports